import React, { useState, useRef } from 'react';
import { Button, Card, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, Slider, Typography } from 'antd';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import JoditEditor from 'jodit-react';

import AppCard from '../../components/AppCard';
import { authorSpecialty, differentialDiagnosis, modalityList, userSpecialty } from '../../utils/Constants';
import { numberValidation } from '../../utils/Validations';

const { Option } = Select;

const CreateQuestion = () => {
  const [form] = Form.useForm();
  const editor = useRef(null);

  const config = {
    readonly: false,
    uploader: {
      url: 'https://bloodlagbe-api.herokuapp.com/api/v1/auth/upload/files',
      insertImageAsBase64URI: false,
      imagesExtensions: ['jpg', 'png', 'jpeg', 'gif'],
      //headers: {"token":`${db.token}`},
      filesVariableName: function (r) {
        return 'images';
      },
      withCredentials: false,
      pathVariableName: 'path',
      format: 'json',
      method: 'POST',
      prepareData: function (formdata) {
        return formdata;
      },
      isSuccess: function (e) {
        console.log(e);
        return e.data.url;
      },
      process: function (resp) {
        let files = [];
        files.unshift(resp.data);
        return {
          files: resp.data,
          error: resp.msg,
          msg: resp.msg,
        };
      },
      // error: function (this, e) {
      //   this.j.e.fire('errorMessage', e.message, 'error', 4000);
      // },
      defaultHandlerSuccess: function (resp) {
        // `this` is the editor.
        console.log(resp);
        console.log(editor);
        // const j = editor;
        // if (resp.files.url) {
        //   // const elm = j.createInside.element('img');
        //   // elm.setAttribute('src', resp.files.url);
        //   // j.s.insertImage(elm, null);

        //   const image = editor.selection.j.createInside.element('img');
        //   image.setAttribute('src', resp.files.url);
        //   editor.selection.insertNode(image);
        // }
      },
      // defaultHandlerError: function (this, e) {
      //   this.j.e.fire('errorMessage', e.message);
      // },
      // contentType: function (e) {
      //   return (
      //     (void 0 === this.jodit.ownerWindow.FormData || 'string' == typeof e) &&
      //     'application/x-www-form-urlencoded; charset=UTF-8'
      //   );
      // },
      // },
    },
  };

  const [questionScenario, setQuestionScenario] = useState('');
  const [optionExplanation, setOptionExplanation] = useState('');
  const [referenceNumber, setReferenceNumber] = useState([1]);
  const [authorNumber, setAuthorNumber] = useState([1]);

  // add new reference
  const addNewReference = () => {
    setReferenceNumber([...referenceNumber, 1]);
  };

  // remove one reference
  const onReferenceCancel = (pos) => {
    let oldData = [];
    for (let i = 0; i < referenceNumber.length; i++) {
      oldData.push({
        idx: i,
        name: form.getFieldValue(`reference_${i + 1}`),
      });
    }

    form.resetFields();
    oldData = oldData.filter((el) => el.idx !== pos);

    for (let i = 0; i < oldData.length; i++) {
      form.setFieldsValue({
        [`reference_${i + 1}`]: oldData[i]['name'],
      });
    }

    const values = [...referenceNumber];
    values.splice(pos, 1);
    setReferenceNumber(values);
  };

  // add new author information
  const addNewAuthor = () => {
    setAuthorNumber([...authorNumber, 1]);
  };

  // remove one author information
  const onAuthorCancel = (pos) => {
    let oldData = [];
    for (let i = 0; i < authorNumber.length; i++) {
      oldData.push({
        idx: i,
        name: form.getFieldValue(`authorName_${i + 1}`),
        specialty: form.getFieldValue(`authorSpecialty_${i + 1}`),
      });
    }

    form.resetFields();
    oldData = oldData.filter((el) => el.idx !== pos);

    for (let i = 0; i < oldData.length; i++) {
      form.setFieldsValue({
        [`authorName_${i + 1}`]: oldData[i]['name'],
        [`authorSpecialty_${i + 1}`]: oldData[i]['specialty'],
      });
    }

    const values = [...authorNumber];
    values.splice(pos, 1);
    setAuthorNumber(values);
  };

  const onSelectAll = (event, name, value) => {
    console.log(event);
    console.log(name);
    console.log(value);
    if (event.includes('all')) {
      form.setFieldsValue({ [name]: value.map((el) => el.id) });
    }
  };

  const onQuestionSubmit = (value) => {
    console.log(value);
    console.log(questionScenario);
  };

  return (
    <div>
      <div className='center'>
        <Typography.Title level={2}>Create Question</Typography.Title>
      </div>

      <Form form={form} onFinish={onQuestionSubmit} layout='vertical' scrollToFirstError initialValues={{ questionType: 'single', patientSex: 'male' }}>
        <Card className='card mb-1' title='Study Information'>
          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item name='questionType' label='Question Type'>
                <Radio.Group buttonStyle='solid'>
                  <Radio.Button value={'single'}>Single</Radio.Button>
                  <Radio.Button value={'multiple'}>Multiple</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='studyAccessionNumber' label='Study Accession number' rules={[{ required: true, message: 'This field is required' }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='studyDate' label='Study Date' rules={[{ required: true, message: 'This field is required' }]}>
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card className='card mb-1' title='Patient Information'>
          <Row gutter={16}>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='patientName' label='Patient Name' rules={[{ required: true, message: 'This field is required' }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item
                name='patientAge'
                label='Patient Age'
                rules={[
                  { required: true, message: 'This field is required' },
                  { pattern: numberValidation, message: 'Number only' },
                ]}>
                <Input style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='patientSex' label='Patient Sex' rules={[{ required: true, message: 'This field is required' }]}>
                <Radio.Group buttonStyle='solid'>
                  <Radio.Button value={'male'}>Male</Radio.Button>
                  <Radio.Button value={'female'}>Female</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card className='card mb-1' title='Author Information'>
          <Row gutter={16}>
            {authorNumber.map((el, i) => (
              <>
                <Col xs={24} md={9} lg={8}>
                  <Form.Item name={`authorName_${i + 1}`} label='Author Name'>
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} md={9} lg={8}>
                  <Form.Item name={`authorSpecialty_${i + 1}`} label='Author Specialty'>
                    <Select showSearch optionFilterProp='children'>
                      {authorSpecialty.map((el) => (
                        <Option value={el.id} key={el.id}>
                          {el.value}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={3} md={2}>
                  <Button type='primary' onClick={addNewAuthor} icon={<PlusOutlined />} style={{ marginTop: '1.8em', marginLeft: '1em' }}></Button>
                </Col>
                <Col xs={2} md={1}>
                  {authorNumber.length > 1 && <Button danger onClick={() => onAuthorCancel(i)} icon={<CloseOutlined />} style={{ marginTop: '1.8em' }}></Button>}
                </Col>
              </>
            ))}
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='authorAffiliation' label='Author Affiliation'>
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card className='card mb-1' title='Study Information'>
          <Row gutter={16}>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='system' label='Select System' rules={[{ required: true, message: 'System is required' }]}>
                <Select>
                  <Option value='all'>Select All</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='organ' label='Select Organ' rules={[{ required: true, message: 'Organ is required' }]}>
                <Select>
                  <Option value='all'>Select All</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='diagnosis' label='Select Diagnosis' rules={[{ required: true, message: 'Diagnosis is required' }]}>
                <Select>
                  <Option value='all'>Select All</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='confidenceInDiagnosis' label='Confidence In Diagnosis'>
                <Slider />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='differential' label='Differential Diagnosis' rules={[{ required: true, message: 'This field is required' }]}>
                <Select optionFilterProp='children' allowClear showSearch>
                  {differentialDiagnosis.map((el) => (
                    <Option value={el.id} key={el.id}>
                      {el.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='appropriateForStudent' label='Appropriate for Student?' rules={[{ required: true, message: 'This field is required' }]}>
                <Radio.Group buttonStyle='solid'>
                  <Radio.Button value={'yes'}>Yes</Radio.Button>
                  <Radio.Button value={'no'}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card className='card mb-1' title='Question Materials'>
          <Row gutter={16}>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='modality' label='Select Modality' rules={[{ required: true, message: 'Modality is required' }]}>
                <Select mode='multiple' showArrow allowClear maxTagCount={2} onChange={(e) => onSelectAll(e, 'modality', modalityList)} optionFilterProp='children'>
                  <Option value='all'>Select All</Option>
                  {modalityList.map((el) => (
                    <Option value={el.id} key={el.id}>
                      {el.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12} lg={8}>
              <Form.Item name='userSpecialty' label='User Specialty' rules={[{ required: true, message: 'This field is required' }]}>
                <Select optionFilterProp='children' showArrow mode='multiple' allowClear onChange={(e) => onSelectAll(e, 'userSpecialty', userSpecialty)}>
                  <Option value={'all'}>Select All</Option>
                  {userSpecialty.map((el) => (
                    <Option value={el.id} key={el.id}>
                      {el.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='contrastedStudy' label='Contrasted Study'>
                <Radio.Group buttonStyle='solid'>
                  <Radio.Button value={'yes'}>Yes</Radio.Button>
                  <Radio.Button value={'no'}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='metastatic' label='Is It Metastatic?'>
                <Radio.Group buttonStyle='solid'>
                  <Radio.Button value={'yes'}>Yes</Radio.Button>
                  <Radio.Button value={'no'}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='trauma' label='Acute Trauma?'>
                <Radio.Group buttonStyle='solid'>
                  <Radio.Button value={'yes'}>Yes</Radio.Button>
                  <Radio.Button value={'no'}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item name='complication' label='Complication' rules={[{ required: true, message: 'This field is required' }]}>
                <Radio.Group buttonStyle='solid'>
                  <Radio.Button value={'yes'}>Yes</Radio.Button>
                  <Radio.Button value={'no'}>No</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name='cause' label='Cause/ Associations'>
                <Input.TextArea />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name='comment' label='Comment From the Author'>
                <Input.TextArea />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card className='card mb-1'>
          <Row>
            <Col xs={24} className='mt-1'>
              <Typography.Title level={5}>Enter Question Scenario</Typography.Title>
              <JoditEditor
                ref={editor}
                value={questionScenario}
                config={{
                  readonly: false,
                  uploader: {
                    url: 'https://bloodlagbe-api.herokuapp.com/api/v1/auth/upload/files',
                    insertImageAsBase64URI: false,
                    //headers: {"token":`${db.token}`},
                    filesVariableName: function (r) {
                      return 'images';
                    },
                    withCredentials: false,
                    pathVariableName: 'path',
                    format: 'json',
                    method: 'POST',
                    prepareData: function (formdata) {
                      return formdata;
                    },
                    isSuccess: function (e) {
                      console.log(e);
                      return e.data.url;
                    },
                    process: function (resp) {
                      let files = [];
                      files.unshift(resp.data);
                      return {
                        files: resp.data,
                        error: resp.msg,
                        msg: resp.msg,
                      };
                    },
                    error: function (e) {
                      this.j.e.fire('errorMessage', e.message, 'error', 4000);
                    },
                    defaultHandlerSuccess: function (resp) {
                      if (resp.files.url) {
                        const image = this.selection.j.createInside.element('img');
                        image.setAttribute('src', resp.files.url);
                        this.selection.insertNode(image);
                      }
                    },
                    defaultHandlerError: function (e) {
                      this.j.e.fire('errorMessage', e.message);
                    },
                  },
                }}
                tabIndex={1}
                onBlur={(newContent) => setQuestionScenario(newContent)}
              />
            </Col>
            <Col xs={24} md={12} className='mt-1'>
              <Typography.Title level={5}>Answer Options</Typography.Title>
              {[1, 2, 3, 4, 5].map((el, i) => (
                <Form.Item name={`option_${i + 1}`} label={`Option ${i + 1}`} key={i}>
                  <Input />
                </Form.Item>
              ))}
            </Col>
            <Col xs={24} className='mt-1 mb-1'>
              <Typography.Title level={5}>Options Explanation</Typography.Title>
              <JoditEditor ref={editor} value={optionExplanation} config={config} tabIndex={1} onBlur={(newContent) => setOptionExplanation(newContent)} />
            </Col>
          </Row>
        </Card>

        <Card className='card mb-1' title='References & Board Pearl'>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item name='boardPearl' label='Board Pearl'>
                <Input.TextArea />
              </Form.Item>
            </Col>
            <Col xs={24}>
              {referenceNumber.map((x, i) => (
                <Row key={i}>
                  <Col xs={24} md={12}>
                    <Form.Item name={`reference_${i + 1}`} label={`Reference ${i + 1}`}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={3} md={2}>
                    <Button type='primary' onClick={addNewReference} icon={<PlusOutlined />} style={{ marginTop: '1.8em', marginLeft: '1em' }}></Button>
                  </Col>
                  <Col xs={1} md={1}>
                    {referenceNumber.length > 1 && <Button danger onClick={() => onReferenceCancel(i)} icon={<CloseOutlined />} style={{ marginTop: '1.8em' }}></Button>}
                  </Col>
                </Row>
              ))}
            </Col>
          </Row>
        </Card>

        <div className='center mt-2'>
          <Button type='default' htmlType='submit' size='large' style={{ marginRight: '1em' }}>
            Save Question
          </Button>
          <Button type='primary' htmlType='submit' size='large'>
            Save and create another question
          </Button>
        </div>
      </Form>
      {/* <div  dangerouslySetInnerHTML={{ __html: editorData }}></div> */}
    </div>
  );
};

export default CreateQuestion;
